module.exports = __webpack_public_path__ + "img/aiapptitle.2b1dc530.png";